"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpFormStatusMessage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SignUpFormStatusMessage = ({ message, buttonLabel, close, }) => {
    (0, react_1.useEffect)(() => {
        // On init focuses the modal description to get screen reader reading the content.
        // Not focusing the dialog itself due to issues in Safari + VO.
        const dialogDescription = document.querySelector('.inner-dialog-accessible-description');
        dialogDescription.focus();
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("p", { children: message }), buttonLabel ? ((0, jsx_runtime_1.jsx)("div", { className: "clearfix flex grid-flow-col justify-items-end pt-6", children: (0, jsx_runtime_1.jsx)("button", { className: "cta cta--small cta--alpha btn-primary btn-large ml-auto", onClick: close, children: (0, jsx_runtime_1.jsx)("span", { className: "cta-content", children: (0, jsx_runtime_1.jsx)("span", { className: "cta-content-text", children: buttonLabel }) }) }) })) : null] }));
};
exports.SignUpFormStatusMessage = SignUpFormStatusMessage;
